package top.wcpe.allincore.dsl.ir.model.statemachine

import top.wcpe.allincore.dsl.ir.model.UiBinding
import top.wcpe.allincore.dsl.ir.model.internal.ReadOnlyOrderedMap

/**
 * 状态机内的单个状态定义。
 *
 * M10 引入：描述某状态下元素需要呈现的属性目标值集合。运行时切换到本状态时，
 * 由 `StateMachineInstance` 把每个 prop 与当前值插值，复用动画调度器。
 *
 * @see UiStateMachine
 */
class UiSmState(
    // val 属性生成 getName()，与原 Java getter 名一致。
    /** 状态名（在所属状态机内唯一）。 */
    val name: String,
    props: Map<String, UiBinding>,
) {

    /** 状态目标属性表，保序、不可变；值类型为通用 [UiBinding]（字面量 / 表达式）。 */
    val props: Map<String, UiBinding>

    init {
        // 防御式保序拷贝，并校验键值非空。
        val copied = LinkedHashMap<String, UiBinding>(props.size)
        for ((key, value) in props) {
            requireNotNull(key) { "state prop key" }
            requireNotNull(value) { "state prop value" }
            copied[key] = value
        }
        this.props = ReadOnlyOrderedMap(copied)
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is UiSmState) return false
        return name == other.name && props == other.props
    }

    // 逐位复刻 Objects.hash(name, props)：种子 1、31 倍累乘。
    override fun hashCode(): Int {
        var result = 1
        result = 31 * result + name.hashCode()
        result = 31 * result + props.hashCode()
        return result
    }

    override fun toString(): String =
        "UiSmState{" + name + ",props=" + props.keys + "}"
}
